import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="bg-white py-32 lg:py-40">
      <div className="w-full px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left Column - Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/c3572f2fc7991bc482df5952ce7ff02c/56fbd06d1f873c3ec04b4e420d071b05.jpeg"
                alt="Equipe Grupo Prime"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating Card */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}
              className="absolute -bottom-8 -right-8 bg-primary rounded-xl p-8 shadow-2xl"
            >
              <p className="text-5xl font-bold text-accent mb-2">2+</p>
              <p className="text-white/60 text-sm">Anos de<br />Excelência</p>
            </motion.div>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-secondary/60 uppercase mb-6">
              Sobre Nós
            </span>
            <h2 className="text-3xl lg:text-4xl font-medium text-primary leading-tight mb-8">
              Estrutura Corporativa<br />
              <span className="text-secondary/40">de Alto Padrão</span>
            </h2>
            
            <div className="space-y-6 mb-10">
              <p className="text-secondary text-lg leading-relaxed">
                O Grupo Prime é um <strong className="text-primary font-medium">grupo corporativo especializado em operações integradas</strong> para eventos e empresas. Através de suas empresas operacionais, oferece soluções completas em valet parking, motorista executivo, logística e movimentação de mobiliário.
              </p>
              <p className="text-secondary text-lg leading-relaxed">
                Nossa estrutura conecta diferentes especialidades sob um único <strong className="text-primary font-medium">padrão de qualidade</strong>, garantindo organização, segurança e eficiência em cada operação.
              </p>
            </div>

            {/* Features */}
            <div className="grid grid-cols-2 gap-6 mb-10">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent/50 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-primary text-lg"></i>
                </div>
                <div>
                  <p className="font-medium text-primary text-sm">Segurança</p>
                  <p className="text-secondary/60 text-xs">Veículos segurados</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent/50 flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-primary text-lg"></i>
                </div>
                <div>
                  <p className="font-medium text-primary text-sm">Equipe Treinada</p>
                  <p className="text-secondary/60 text-xs">Profissionais qualificados</p>
                </div>
              </div>
            </div>

            <Link
              to="/o-grupo"
              className="inline-flex items-center gap-2 text-primary font-medium text-sm hover:gap-4 transition-all duration-300 cursor-pointer"
            >
              Conheça nossa história
              <i className="ri-arrow-right-line"></i>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
